module.exports = __webpack_public_path__ + "Assets/3963cec0-c35f-41fa-adb6-4ef3fc0bb056.woff";